import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { ContractContextMenuService, TContextTarget } from '../../services/contract-context-menu.service';
@Component({
    selector: 'app-contract-context-menu',
    templateUrl: './contract-context-menu.component.html',
    styleUrl: './contract-context-menu.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractContextMenuComponent {
  @Input() inputData!: any;
  @Input() targetContext!: TContextTarget;
  @Input() contractGuid: string = '';
    constructor(
      public contextMenuService:ContractContextMenuService,
    ) { }
    editEvent(event:MouseEvent) {
      this.contextMenuService.dispatchEditEvent(event,this.targetContext,this.inputData, this.contractGuid)
    }
    createEvent(event:MouseEvent) {
      this.contextMenuService.dispatchCreateEvent(event,this.targetContext,this.inputData, this.contractGuid)
    }
    deleteEvent(event:MouseEvent) {
      this.contextMenuService.dispatchDeleteEvent(event,this.targetContext,this.inputData, this.contractGuid)
    }
}